export default __webpack_public_path__ + "static/media/forgive_3.602234c9.jpg";